import { useEffect } from 'react';

export default function useOutsideClick(ref, action) {
  useEffect(() => {
    const refsArray = Array.isArray(ref) ? ref : [ref];
    const allRefsExist = refsArray.every((r) => r.current !== null);

    const handleClickOutside = (event) => {
      const clickedOutside = allRefsExist ? refsArray.every((r) => r.current && !r.current.contains(event.target)) : true;
      if (clickedOutside) {
        action();
      }
    };

    if (allRefsExist) {
      // Bind the event listener
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('touchstart', handleClickOutside);
    }

    return () => {
      // Unbind the event listener on cleanup
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [ref, action]);
}
